import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { LoginRouting } from './login.routing';
import { LoginLayoutComponent } from './layout/login-layout.component';
import { AccountSelectorComponent } from './account_selector/account-selector.component';
import { LoginSelectorComponent } from './selector/login-selector.component';

@NgModule({
  declarations: [
    LoginLayoutComponent,
    AccountSelectorComponent,
    LoginSelectorComponent,
  ],
  exports: [
    LoginLayoutComponent,
    AccountSelectorComponent,
    LoginSelectorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    LoginRouting,
  ],
})
export class LoginModule {
  constructor() {}
}
